import { dehydrate, QueryClient } from '@tanstack/react-query'
import type {
  AdminListProjectsParams,
  AdminCreateProjectInput,
  AdminGetProjectParams,
  AdminGetProjectPriceExprParams,
  AdminListProjectAgentLinksParams,
  AdminGetProjectAgentLinksParams,
} from '../api'
import projectService from './admin-project.service'
import { EAdminProjectQueryKey } from './admin-project.types'

export const adminGetProjectDetailsOptions = (
  params: AdminGetProjectParams,
) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminGetProjectDetails(params),
  }
}

export const prefetchAdminGetProjectDetails = async (
  params: AdminGetProjectParams,
) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(adminGetProjectDetailsOptions(params))
  return dehydrate(queryClient)
}

export const adminListProjectsOptions = (params: AdminListProjectsParams) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminListProjects(params),
  }
}

export const adminCreateProjectOptions = (params: AdminCreateProjectInput) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminCreateProject(params),
  }
}

export const adminUploadProjectPhotoOptions = (params: FormData) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminUploadProjectPhoto(params),
  }
}

export const adminUploadProjectLogoOptions = (params: FormData) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminUploadProjectLogo(params),
  }
}

export const adminUploadProjectDocumentOptions = (params: FormData) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, params],
    queryFn: () => projectService.adminUploadProjectDocument(params),
  }
}

export const adminDeleteProjectDocumentOptions = (
  projectId: number,
  documentId: number,
) => {
  return {
    mutationKey: [
      EAdminProjectQueryKey.ADMIN_PROJECT,
      'delete-document',
      projectId,
      documentId,
    ],
    mutationFn: () =>
      projectService.adminDeleteProjectDocument(projectId, documentId),
  }
}

export const adminDeleteProjectPhotoOptions = (
  projectId: number,
  photoId: number,
) => {
  return {
    mutationKey: [
      EAdminProjectQueryKey.ADMIN_PROJECT,
      'delete-photo',
      projectId,
      photoId,
    ],
    mutationFn: () =>
      projectService.adminDeleteProjectPhoto(projectId, photoId),
  }
}

export const adminGetProjectPriceExprOptions = (
  params: AdminGetProjectPriceExprParams,
) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_PROJECT, 'price-expr', params],
    queryFn: () => projectService.adminGetProjectPriceExpr(params),
  }
}

export const prefetchAdminGetProjectPriceExpr = async (
  params: AdminGetProjectPriceExprParams,
) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(adminGetProjectPriceExprOptions(params))
  return dehydrate(queryClient)
}

export const adminListProjectAgentLinksOptions = (
  params: AdminListProjectAgentLinksParams,
) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_LIST_PROJECT_AGENT_LINKS, params],
    queryFn: () => projectService.adminListProjectAgentLinks(params),
  }
}

export const adminGetProjectAgentLinksOptions = (
  params: AdminGetProjectAgentLinksParams,
) => {
  return {
    queryKey: [EAdminProjectQueryKey.ADMIN_GET_PROJECT_AGENT_LINKS, params],
    queryFn: () => projectService.adminGetProjectAgentLinks(params),
  }
}
